import React from 'react';

function LevelIndicator({ value }) {
  //   const value = Math.min(Math.max(value, 0), 1); // Clamp value between 0 and 1 (0 for empty, 1 for full)
  // console.log(value, "value")
  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      {/* Outer level container */}
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <div
          style={{
            position: 'absolute',
            left: '-35px',
            height: '100px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            fontSize: '10px',
            color: '#333',
          }}
        >
          {["Full", "Empty"].map((temp) => (
            <div key={temp}>{temp}</div>
          ))} 
        </div>
        <div
          style={{
            width: '20px',
            height: '100px',
            background: '#f0f0f0',
            border: '4px solid #ccc',
            borderRadius: '20px',
            position: 'relative',
            margin: '0 auto',
            overflow: 'hidden',
          }}
        >
          {/* Inner level fill (green for full, transparent for empty) */}
          <div
            style={{
              width: '100%',
              height: value === 1 ? "100px" : "20px",
              background: value === 1 ? 'rgba(0, 255, 0, 0.7)' : 'red', // Green for full, transparent for empty
              position: 'absolute',
              bottom: '0',
              borderRadius: '20px 20px 0 0',
              transition: 'height 0.5s ease, background 0.5s ease',
            }}
          ></div>
        </div>
      </div>
      {/* Level value display */}
      {/* <p style={{ fontSize: '12px', fontWeight: 'bold', marginTop: '5px', textAlign: "center" }}>
        {value === 1 ? '' : ''}
      </p> */}
    </div>
  );
}

export default LevelIndicator;
